'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _utils = require('../decorators/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var capitalize = function capitalize(str) {
  return str[0].toUpperCase() + str.slice(1);
};

var consumerDecoratorFactory = function consumerDecoratorFactory(contextName, Consumer) {
  return function (Component) {
    var contextPropName = contextName + 'Context';

    var ConsumesContextComponent = function (_React$Component) {
      _inherits(ConsumesContextComponent, _React$Component);

      function ConsumesContextComponent() {
        _classCallCheck(this, ConsumesContextComponent);

        return _possibleConstructorReturn(this, (ConsumesContextComponent.__proto__ || Object.getPrototypeOf(ConsumesContextComponent)).apply(this, arguments));
      }

      _createClass(ConsumesContextComponent, [{
        key: 'render',
        value: function render() {
          var _this2 = this;

          return _react2.default.createElement(
            Consumer,
            null,
            function (context) {
              var props = _extends({}, _this2.props, _defineProperty({}, contextPropName, context));
              return _react2.default.createElement(Component, _extends({}, props, {
                ref: function ref(wrappedInstance) {
                  (0, _utils.copyMethods)(wrappedInstance, _this2);
                }
              }));
            }
          );
        }
      }]);

      return ConsumesContextComponent;
    }(_react2.default.Component);

    // Omit context prop from propTypes


    ConsumesContextComponent.propTypes = _extends({}, Component.propTypes);
    delete ConsumesContextComponent.propTypes[contextPropName];

    ConsumesContextComponent.defaultProps = Component.defaultProps;

    ConsumesContextComponent.displayName = 'Consumes' + capitalize(contextName) + 'Context(' + Component.displayName + ')';
    (0, _utils.attachWrappedComponent)(ConsumesContextComponent, Component);
    return ConsumesContextComponent;
  };
};

exports.default = consumerDecoratorFactory;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.1115/js/context/consumerDecoratorFactory.js
// module id = 312
// module chunks = 0